import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Text } from '@grandvisionhq/elements';
import { useIntl, useFeatureToggles } from '@grandvisionhq/state';
import { Product } from '../components/Product.js';
import { getLineItemBody } from '../utils/get-product-body.js';

const LineItemsContainer = ({ lineItems  })=>{
    const { getLabel  } = useIntl();
    const { isDownloadQuotationEnabled  } = useFeatureToggles();
    const labels = React.useMemo(()=>({
            monthlySubscription: getLabel('products.monthlySubscription'),
            quantity: getLabel('cart.item.quantity'),
            unitMilli: getLabel('products.unit.metric.liter.milli.abbr'),
            leftEye: getLabel('products.contactLenses.leftEye'),
            rightEye: getLabel('products.contactLenses.rightEye'),
            quotation: getLabel('products.contactLenses.quotationMiniCart'),
            power: getLabel('products.contactLenses.prescription.power')
        })
    , [
        getLabel
    ]);
    const products = React.useMemo(()=>lineItems.map((lineItem)=>({
                sku: lineItem.type === 'prescription-glasses' ? lineItem.frame.sku : lineItem.sku,
                imageUrl: lineItem.imageUrl,
                price: {
                    discountedPrice: lineItem.price.total.discount ? lineItem.price.total.gross : undefined,
                    originalPrice: lineItem.price.total.original,
                    currency: lineItem.currency
                },
                title: lineItem.name,
                quotation: {
                    isEnabled: lineItem.type === 'contact-lenses' && isDownloadQuotationEnabled,
                    text: labels.quotation
                },
                body: /*#__PURE__*/ React.createElement(Text, {
                    component: "span",
                    variant: "body"
                }, getLineItemBody(lineItem, labels))
            })
        )
    , [
        lineItems,
        isDownloadQuotationEnabled,
        labels
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, products.map((product)=>/*#__PURE__*/ React.createElement(Product, swcHelpers.extends({
            key: product.sku
        }, product))
    ));
};

export { LineItemsContainer };
//# sourceMappingURL=LineItemsContainer.js.map
